import { useNavState } from '../navState/NavStateContext';
import { usePrincipal } from '../principal/PrincipalContext';
import { SideNavButton } from './SideNavButton';

export const OrgIcon = () => {
  const { org } = usePrincipal();
  const { navigateTo } = useNavState();

  return (
    <SideNavButton
      onClick={() => navigateTo('/')}
      
      imgUrl = {`/assets/icons/${org.toLowerCase()}.png`}
      label="Home"
    />
  )
}